








































































import Vue from 'vue'
import Component from 'vue-class-component'
import router from '../router'
import { Auth } from 'aws-amplify'
import Authentication, { AuthenticationError } from '../provider/authentication'

@Component
export default class LoginForm extends Vue {
  userId: string = ''
  password: string = ''
  loginFailedSnackbar: boolean = false
  loginFailedText: string = ''
  loginButtonLoading: boolean = false
  passwordChangeDialog: boolean = false
  newPassword: string = ''
  user: any

  async submitNewPassword () {
    try {
      await Auth.completeNewPassword(this.user, this.newPassword, {})
      this.password = this.newPassword
      this.passwordChangeDialog = false
      this.submit()
    } catch (e) {
      console.log(e)
      this.loginFailedText = '不正なパスワードです。8文字以上で数字、大文字、小文字を含むパスワードにしてください。'
      this.loginFailedSnackbar = true
    }
  }

  async submit () {
    this.loginButtonLoading = true
    try {
      await this.authentication(this.userId, this.password)
      router.push({ name: 'User' })
    } catch (e) {
      console.log(e)
      if (e === 'NotAdminUserException') {
        this.loginFailedText =
          '管理権限を持つユーザーではありません。管理権限を持つユーザーでログインしてください。'
      } else if (e === 'EmailNotConfirmedException') {
        this.loginFailedText =
          'メールアドレスが認証されていないアカウントです。ユーザー作成時にメールアドレスを認証済みにして作成してください。'
      } else if (e === 'MultipleAdminGroupAssigned') {
        this.loginFailedText =
          '複数の管理者権限が付与されています。単一の管理者権限のみが付与されているか確認してください。'
      } else if (e === 'InvalidAdminType') {
        this.loginFailedText = '存在しないグループの管理者権限です。正しい管理者権限が付与されているか確認してください。'
      } else {
        this.loginFailedText =
          'ログインに失敗しました。IDとパスワードを確認してください。'
      }
      this.loginFailedSnackbar = true
    }
    this.loginButtonLoading = false
  }

  async authentication (userId: string, password: string): Promise<void> {
    console.log('sign in')
    try {
      this.user = await Auth.signIn(userId, password)
      if (this.user.challengeParam && this.user.challengeParam.requiredAttributes && this.user.challengeParam.requiredAttributes.includes('email')) {
        throw new AuthenticationError('EmailNotConfirmedException')
      }
      // 初回ログイン
      if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.passwordChangeDialog = true
        return
      }
      this.user = await Auth.currentAuthenticatedUser()
      await Authentication.auth(this.user)
    } catch (e) {
      await Auth.signOut()
      console.log('error', e)
      if (e instanceof AuthenticationError) {
        throw e.code
      }
      throw e
    }
  }
}
